export const PAYABLE_STATUS_PT: Record<string, string> = {
  OPEN: "ABERTO",
  PARTIAL: "PARCIAL",
  PAID: "PAGO",
  CANCELED: "CANCELADO",
  OVERDUE: "VENCIDO",
};

export const RECEIVABLE_STATUS_PT: Record<string, string> = {
  OPEN: "ABERTO",
  PARTIAL: "PARCIAL",
  RECEIVED: "RECEBIDO",
  CANCELED: "CANCELADO",
  OVERDUE: "VENCIDO",
};

export const OPERATION_NATURE_PT: Record<string, string> = {
  OPEX: "OPEX",
  CAPEX: "CAPEX",
  FINANCE: "FINANCEIRO",
  OTHER: "OUTROS",
};
